import script from "./InputField.vue?vue&type=script&lang=ts&setup=true"
export * from "./InputField.vue?vue&type=script&lang=ts&setup=true"

import "./InputField.vue?vue&type=style&index=0&id=6b0810e6&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b0810e6"]])

export default __exports__